/* 🤖 this file was generated by svg-to-ts */
export const mgcIconArrowLeftUpRegular: {
  name: 'arrow-left-up-regular';
  data: string;
} = {
  name: 'arrow-left-up-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.673 5.063c-.244.075-.523.351-.609.603C5.007 5.834 5 6.303 5 10c0 4.672-.019 4.374.306 4.7.18.179.458.3.694.3.237 0 .514-.12.697-.303.313-.313.303-.202.303-3.434V8.42l5.03 5.029c3.93 3.928 5.069 5.045 5.21 5.108a1.02 1.02 0 0 0 1.117-.2 1.02 1.02 0 0 0 .2-1.117c-.063-.141-1.18-1.28-5.108-5.21L8.42 7h2.843c3.232 0 3.121.01 3.434-.303.183-.183.303-.46.303-.697 0-.402-.312-.827-.69-.939-.299-.089-8.348-.087-8.637.002"/></svg>`
};
